module.exports = __webpack_public_path__ + "img/hero--photo.f8325463.png";